import { dataFolderDownload } from 'dls-icons-data'
import { createIcon } from '../common'

const IconFolderDownload = /*#__PURE__*/createIcon(dataFolderDownload)
export default IconFolderDownload
